<template>
  <v-container>
    <AddEmployee @refresh-employee-list="handleEmployeeAdded" />
    <v-card title="Employee List" flat>
      <v-row class="px-4 align-center justify-space-between">
        <v-col cols="2" class="mr-auto d-flex align-center">
          <label class="mr-3" style="font-weight: 400">Show</label>
          <v-select
            v-model="itemsPerPage"
            :items="[10, 20, 50]"
            variant="outlined"
            hide-details
            class="w-25 v-custom-select"
            dense
          />
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="search"
            label="Search"
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            hide-details
            class="w-100 v-custom-select"
            dense
          />
        </v-col>
      </v-row>
      <v-row class="pa-4">
        <v-btn color="primary" class="ml-3" dense @click="exportToCSV">
          CSV
        </v-btn>
        <v-btn color="primary" class="ml-3" dense @click="exportToPDF">
          PDF
        </v-btn>
        <v-btn color="primary" class="ml-3" dense @click="printTable">
          Print
        </v-btn>
      </v-row>
      <v-data-table
        :headers="headers"
        :items="employees"
        :search="search"
        :items-per-page="itemsPerPage"
        item-value="id"
        item-class="getItemClass"
        class="employee-table elevation-1 mt-4"
      >
        <template v-slot:[`item.name`]="{ item }">
          <v-row align="center" no-gutters>
            <v-col class="d-flex align-center pa-2">
              <v-img
                :src="item.image || noImage"  
                :alt="item.name"
                class="student-image mrr-10"
                alt="Employee Image"
                contain
              />

              <span>{{ capitalize(item.name) }}</span>
            </v-col>
            <!-- <v-col class="d-flex align-left justify-start pl-3 ">
              </v-col> -->
          </v-row>
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <v-row align="center" no-gutters>
            <v-col class="d-flex align-center pa-2">
              <v-img
                :src="item.image || noImage"
                :alt="item.name"
                class="student-image mrr-10"
                alt="Employee Image"
                contain
              />

              <span>{{ capitalize(item.name) }}</span>
            </v-col>
            <!-- <v-col class="d-flex align-left justify-start pl-3 ">
              </v-col> -->
          </v-row>
        </template>

        <template v-slot:[`item.designation`]="{ item }">
          <v-row align="center" no-gutters>
            <span>{{ capitalize(item.designation) }}</span>
          </v-row>
        </template>
        <!-- <template v-slot:[`item.gender`]="{ item }">
          <v-row align="center" no-gutters>
            <span>{{ capitalize(item.gender) }}</span>
          </v-row>
        </template> -->
        <template v-slot:[`item.blood_group`]="{ item }">
          <v-row align="center" no-gutters>
            <span>{{ capitalize(item.blood_group) }}</span>
          </v-row>
        </template>
        <template v-slot:[`item.address`]="{ item }">
          <v-row align="center" no-gutters>
            <span>{{ capitalize(item.address) }}</span>
          </v-row>
        </template>
        <!-- <template v-slot:[`item.teaching_level`]="{ item }">
          <v-row align="center" no-gutters>
            <span>{{ capitalize(formatText(item.teaching_level.value)) }}</span>
          </v-row>
        </template>
        <template v-slot:[`item.category`]="{ item }">
          <v-row align="center" no-gutters>
            <span>{{ capitalize(formatText(item.category.value)) }}</span>
          </v-row>
        </template> -->

        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex justify-space-between">
            <v-btn icon @click="editEmployee(item)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn icon @click="deleteEmployee(item.id)">
              <v-icon color="red">mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>

        <template v-slot:footer="{ props }">
          <v-row class="align-center">
            <v-col cols="auto">
              <span class="footer-text">Total Employees:</span>
            </v-col>
            <v-col cols="auto">
              <v-data-table-footer
                :props="props"
                class="d-flex justify-start align-center"
              />
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="isEditDialogOpen" max-width="800">
      <UpdateEmployee
        :employee="selectedEmployee"
        @updateEmployeed="handleEmployeeUpdate"
        @close="isEditDialogOpen = false"
      />
    </v-dialog>
  </v-container>

</template>

<script setup>
import axios from "axios";
import Swal from "sweetalert2";
import { ref, onMounted, onBeforeMount, watch } from "vue";
import { getEmployee } from "@/services/apiServices";
import AddEmployee from "@/components/Apps/Employee/addEmployee.vue";
// import BaseButton from "@/components/Apps/cardSample/BaseButton.vue";
import UpdateEmployee from "@/components/Apps/Employee/UpdateEmployee.vue";
import { jsPDF } from "jspdf";
import { autoTable } from "jspdf-autotable";
import Papa from "papaparse";
import { apiConfig } from "@/config/apiConfig";
import banner1 from "@/assets/images/administrator.jpg";
import noImage from "@/assets/images/image_not_available-removebg-preview (1).png"
const search = ref("");
// const currentPage = ref(5);
const itemsPerPage = ref(10);
const employees = ref([]);
// const isAddDialogOpen = ref(false);
const isEditDialogOpen = ref(false);
const selectedEmployee = ref(null);
const headers = ref([
  { align: "start", key: "employee_id", title: "EID" },
  { key: "name", sortable: true, title: "Name" },
  // { key: "gender", title: "Gender" },
  { key: "designation", title: "Designation" },
  { key: "blood_group", title: "Blood Group" },
  { key: "address", title: "Address" },
  // { key: "teaching_level", title: "Teaching Level" },
  // { key: "category", title: "Category" },
  // { key: "appointment", title: "Appointment" },
  { key: "contact", title: "Contact" },
  { key: "actions", title: "Actions", sortable: false },
]);

const handleEmployeeAdded = (newEmployee) => {
  employees.value.push(newEmployee);
};

const fetchEmployees = async () => {
  try {
    const response = await getEmployee();
    employees.value = response || [];
  } catch (error) {
    console.error("Error fetching employees:", error);
  }
};

const capitalize = (text) => {
  if (typeof text !== "string" || text.length === 0) {
    return "";
  }
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

const formatText = (text) => {
  if (typeof text !== "string" || text.length === 0) {
    return "";
  }
  return text
    .split("_")
    .map((word) => capitalize(word))
    .join(" ");
};

const editEmployee = (employee) => {
  selectedEmployee.value = { ...employee };
  isEditDialogOpen.value = true;
  // console.log("selectedEmployee", selectedEmployee);
};

// const handlePageChange = (page) => {
//   currentPage.value = page;
//   fetchEmployees();
// };

// const handleItemsPerPageChange = (value) => {
//   itemsPerPage.value = value;
//   fetchEmployees();
// };

const handleEmployeeUpdate = (updatedEmployee) => {
  const index = employees.value.findIndex(
    (employee) => employee.id === updatedEmployee.id
  );
  if (index !== -1) {
    employees.value[index] = updatedEmployee;
  }
  isEditDialogOpen.value = false;
  Swal.fire("Success", "Employee Update successfully!", "success");
};

const deleteEmployee = async (empID) => {
  try {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      const { status } = await axios.delete(
        `${apiConfig.baseUrl}${apiConfig.employee}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            "EMPLOYEE-ID": empID,
          },
        }
      );

      if (status === 200 || status === 204) {
        employees.value = employees.value.filter(
          (employee) => employee.id !== empID
        );
        Swal.fire("Deleted!", "Employee deleted successfully.", "success");
      }
    }
  } catch (error) {
    console.error("Error deleting employee:", error);
    Swal.fire("Error", error.message, "error");
  }
};

const exportToCSV = () => {
  const csv = Papa.unparse(
    employees.value.map((employee) => {
      // Filter out unwanted fields
      const { school, class_info, image, ...rest } = employee;
      rest.category = employee.category?.name || "N/A";
      rest.teaching_level = employee.teaching_level?.name || "N/A";
      return rest;
    })
  );

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", "employees_list.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};


const exportToPDF = () => {
  const doc = new jsPDF();
  const columns = [
    "EID",
    "Name",
    "Gender",
    "Blood Group",
    "Teaching Level",
    "Category",
    "Designation",
    "Contact",
  ];

  const rows = employees.value.map((employee) => [
    employee.employee_id,
    employee.name,
    employee.gender,
    employee.blood_group,
    employee.teaching_level?.name || "N/A",
    employee.category?.name || "N/A",
    employee.designation,
    employee.contact,
  ]);

  autoTable(doc, {
    head: [columns],
    body: rows,
    startY: 20, // Start drawing the table from Y=20 (below the title)
    margin: { top: 30 }, // Add a top margin if necessary
    styles: {
      fontSize: 10,
      cellPadding: 3,
    },
    headStyles: {
      fillColor: [22, 160, 133],
      textColor: [255, 255, 255],
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [240, 240, 240],
    },
  });

  doc.save("employees_list.pdf");
};

const printTable = () => {
  if (!employees.value.length) {
    console.error("No data to print");
    return;
  }

  let tableHtml = `<table border="1" width="100%">
    <thead>
      <tr>`;

  // Exclude the 'actions' column from the header
  headers.value.forEach((header) => {
    if (header.key !== "actions") {
      tableHtml += `<th>${header.title}</th>`;
    }
  });

  tableHtml += `</tr>
    </thead>
    <tbody>`;

  employees.value.forEach((employee) => {
    tableHtml += `<tr>`;
    headers.value.forEach((header) => {
      if (header.key !== "actions") {
        let value = employee[header.key];

        if (typeof value === "object" && value !== null) {
          if (header.key === "teaching_level") {
            value = value.name || "N/A"; 
          } else if (header.key === "category") {
            value = value.name || "N/A"; 
          } else {
            value = "N/A"; 
          }
        }

        tableHtml += `<td>${value || ""}</td>`;
      }
    });
    tableHtml += `</tr>`;
  });

  tableHtml += `</tbody>
  </table>`;

  const w = window.open("", "", "width=800,height=600");

  w.document.write(`
    <html>
      <head>
        <title>Employee List</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; color: #333; background-color: #fff; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { padding: 12px 15px; text-align: left; border-bottom: 1px solid #ddd; }
          th { background-color: #f4f4f4; font-weight: bold; }
          tr:nth-child(even) { background-color: #f9f9f9; }
          @media print {
            body { margin: 0; padding: 0; }
            table { width: 100%; }
            th, td { font-size: 12px; padding: 8px; }
          }
        </style>
      </head>
      <body>
        
        ${tableHtml}
      </body>
    </html>
  `);

  w.document.close();

  setTimeout(() => {
    w.focus();
    w.print();
    w.close();
  }, 500);
};

onBeforeMount(fetchEmployees);

const getItemClass = (_, index) => {
  return index % 2 === 0 ? "even-row" : "odd-row";
};
</script>

<style>
.v-data-table {
  padding: 0 10px;
}

/* table ko heading ko data haru */
.v-data-table th.v-data-table__td {
  font-weight: 900;
  font-size: 17px;
  margin-bottom: 125px;
  background-color: #e4f3f8;
  padding: 0rem 1rem !important;
}

/* td ka row */
.v-data-table__tr {
  font-weight: 900;
  font-size: 15px;
}

.word-wrap-text {
  display: block;
  max-width: 210px;
  white-space: nowrap;
  overflow: hidden;
  word-wrap: break-word;

  /* text-overflow: ellipsis;    Adds ellipsis (...) if the text overflows */
}

.v-data-table__td.v-data-table-column--align-start {
  padding: 0 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* background-color: #07eb1ac9; */
}

/* .v-img.student-image {
  max-width: 40px !important;
  max-height: 40px !important;
  width: 100% !important;
  height: auto !important;
  background-color: rgb(36, 15, 153) !important;
  border-radius: 100%;
  padding: 12px;
} */

/* .v-img.student-image {
  width: 30px !important;
  height: 30px !important;
  background-color: rgb(36, 15, 153) !important;
  border-radius: 50%;
  padding: 4px;
  object-fit: cover;
} */

.v-img.student-image {
  width: 35px !important;
  height: 35px !important;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid #c2cdff; 
  padding: 0; 
}


.v-img__img.v-img__img--contain {
  /* object-fit: contain; */
  /* width: 140px;
  height: 140px;  */
  object-fit: contain !important;
  /* border-radius: 50%; */
}

/* seach garne haru jasta field haru ko */
.v-custom-select .v-field {
  height: 35px;
  display: flex;
  background-color: #e0b4b438;
  justify-content: center;
}

/* show numbers ka  */
.v-custom-select .v-input__control .v-field__input {
  min-height: 10px !important;
  max-height: 50px !important;
  height: 35px !important;
  padding: 0 20px !important;
  /* background-color: #e71616d8; */
}

/* down arrow ko */
.v-custom-select .v-input__control .v-field__append-inner {
  height: 38px;
  /* background-color: #ec040438; */
}

.v-data-table-footer {
  display: flex;
  justify-content: start;
  align-items: center;
  padding: 0 20px;
}

.v-data-table-footer__items-per-page {
  display: flex;
  justify-content: start !important;
  display: none;
}

.employee-table .v-data-table-footer__info::before {
  content: "Total Employees: ";
  margin-right: 10px;
}

.v-data-table-footer__pagination {
  display: flex;
  justify-content: start;
}

.mrr-10 {
  margin-right: 10px;
}

/* Theme */

.v-overlay__scrim {
  backdrop-filter: blur(11px);
  background-color: rgba(248, 244, 244, 0.2) !important;
}

.v-dialog {
  background-color: rgba(40, 41, 38, 0.596) !important;
  /* box-shadow: 0px 4px 15px rgba(255, 212, 212, 0.2); */
  border-radius: 8px;
}

.v-theme--dark .v-overlay__scrim {
  backdrop-filter: blur(11px);
  background-color: rgba(236, 39, 39, 0.2) !important;
}

.v-theme--dark .v-dialog {
  background-color: rgb(223, 199, 199) !important;
  /* box-shadow: 0px 4px 15px rgba(255, 212, 212, 0.2); */
  border-radius: 8px;
}

/* Light mode */
.v-data-table .v-data-table__tr:nth-child(even) {
  background-color: #f3f6f7;
  white-space: nowrap;
}

.v-data-table .v-data-table__tr:nth-child(odd) {
  background-color: #fbfbfb;
  white-space: nowrap;
}

/* Dark mode */
.v-theme--dark .v-data-table .v-data-table__tr:nth-child(even) {
  background-color: #1d1616;
}

.v-theme--dark .v-data-table .v-data-table__tr:nth-child(odd) {
  background-color: #1e201e;
}

.v-data-table__tr .v-btn {
  margin: 0 3px;
  padding: 0px 10px;
  min-width: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: transparent;
  /* background-color: red; */
  color: #000;
}

.v-data-table__tr .v-btn .mdi-pencil {
  margin: 0;
  padding: 10px;
  min-width: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: transparent;
  color: #a59e9e;
}

.v-theme--dark .v-data-table th.v-data-table__td {
  background-color: #28ca8c52;
}
</style>
